<template lang="pug">
.v-field-map.field-map
	.field-check-list__label(v-if="field.label" :id="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.field-map__map(id='map')
	button.field-map__zoom-button(type="button" @click="openModal")
		v-svg-icon.field-map__zoom-button--icon(icon="open-full")
	.field-map__confirm
		v-field-checkbox(
			:text="field.confirm"
			v-model="confirmed"
			@update:model-value="setConfirm")
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"
import uniqueId from '../scripts/helpers/uniqueId.js';
import controller from "../scripts/controller/controller.js";

export default {
	props: {
		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			confirmed: null,
			position: null,
			zoom: null,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},

		field() {
			this.setInitValue();
			this.initMap()
		}
	},

	created() {
		this.updateLocalValue();
		this.setInitValue();
	},

	mounted() {
		this.initMap();
	},

	methods: {
		initMap() {
			const loader = new Loader({
				apiKey: "AIzaSyAci1VG7P-E3ci2nPTSgIuLbAGH9PXGANI",
				version: "weekly",
				language: "en"
			});
			console.log('position init',this.position)
			loader.load().then(async () => {
				const { Map } = await google.maps.importLibrary("maps");
				const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
				const map = new Map(document.getElementById("map"), {
					center: this.position,
					zoom: this.zoom,
					streetViewControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					clickableIcons: false,
					mapId: '952e5846ea5cd60b'
				});

				if(this.field?.bounds) {
					map.fitBounds({
						"south": Number(this.field.bounds.southwest.lat),
						"west": Number(this.field.bounds.southwest.lng),
						"north": Number(this.field.bounds.northeast.lat),
						"east": Number(this.field.bounds.northeast.lng)
					})
				}

				const markerImg = document.createElement("img");
				markerImg.src = this.field?.src

				const advancedMarker = new AdvancedMarkerElement({
					map,
					position: this.position,
					content: markerImg,
					gmpDraggable: !this.confirmed,
				});

				advancedMarker.addListener('dragend', () => {
					this.zoom = map.zoom
					this.position = advancedMarker.position
					this.localValue = {lat: this.position.lat, lng: this.position.lng, zoom: this.zoom, confirmed: this.confirmed}
					this.handleInput()
				})
			})
		},

		openModal() {
			controller.openModal({
				className: 'map-zoomed',
				component: {
					name: "v-modal-map",
					props: {
						dataSource: {
							zoom: this.zoom,
							position: this.position,
							marker: this.field?.src,
							confirmed: this.confirmed
						}
					},
					listeners: {
						'set-position': async (data) => {
							this.localValue = data;
							this.zoom = data.zoom;
							this.position = {'lat': data.lat, 'lng': data.lng}

							this.initMap();
						}
					}
				},

			});
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		},

		setConfirm() {
			this.initMap()
		},

		setInitValue() {
			if(this.localValue?.lat && this.localValue?.lng) {
				this.position = {lat: Number(this.localValue.lat), lng: Number(this.localValue.lng)}
			} else if (this.field.center && this.field.center.lat && this.field.center.lng) {
				this.position = {lat: Number(this.field.center.lat), lng: Number(this.field.center.lng)}
			} else {
				this.position = {lat: 35, lng: 33.3}
			}

			if(this.localValue?.zoom) {
				this.zoom = Number(this.localValue.zoom)
			} else if(this.field.center && this.field.center.zoom) {
				this.zoom = Number(this.field.center.zoom)
			} else {
				this.zoom = 8
			}

			this.confirmed = !!this.localValue?.confirmed
		}

	}
};
</script>